import AddIcon from '@material-ui/icons/Add'
import { ButtonType } from '../../../model/button'

import { componentBoxShowAction } from 'src/reducers/component-box/action'
import {
  AddMember,
  ImportMembers,
} from 'src/pages/collection/components/collection-page-view/components/learners/components/teams-member-list/components'
import ComponentBoxContent from 'src/model/component-box'
import { teamsMemberExportAction } from 'src/reducers/teams/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import CollectionSelectionModal from 'src/components/collection-select-modal'

const actions = [
  {
    label: '',
    items: [],
  },
]

export default actions
